document.addEventListener('click', event => {
  const button = event.target.closest('.hr-film-start');
  if (!button) return;
  const cinema = button.closest('.hr-cinema');
  const video = cinema.querySelector('video');
  const error = cinema.querySelector('.hr-video-error');
  video.addEventListener('error', () => { error.hidden = false; }, { once: true });
  video.src = video.dataset.src;
  video.hidden = false;
  button.hidden = true;
  video.focus();
  video.play().catch(() => { if (video.error) error.hidden = false; });
});
